import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('hlr')
  .add('hlr.breadcrumb.title', { name: 'hlr.requests.index' });

const requests_breadcrumbs = module
  .extend('hlr.requests.index')
  .add('hlr.breadcrumb.requests.index', {
    name: `hlr.requests.index`
  });

const hlr_breadcrumbs = [module, requests_breadcrumbs];

export { hlr_breadcrumbs };
